const getFontWeight = size => {
  switch (size) {
    case 'small':
      return 500
    case 'large':
      return 550
    case 'medium':
    default:
      return 500
  }
}

export default getFontWeight
